import { PricebookType } from "data/Pricebook";

export const GLOBAL_PRICEBOOK = 'GLOBAL';
export const COUNTRY_PRICEBOOK = 'COUNTRY';
export const WAREHOUSE_PRICEBOOK = 'WAREHOUSE';

export const COMPANY_PRICEBOOK_FILEPATH = '/Company Template.xlsx';
export const AFFILIATE_COMPANY_PRICEBOOK_FILEPATH = '/Affiliate Company Template.xlsx';
export const GEOGRAPHY_PRICEBOOK_FILEPATH = '/Geography Template.xlsx';
export const REFERENCE_PRICEBOOK_FILEPATH = '/Reference Template.xlsx';

/**
 * Resolves the template file path for a pricebook based on its type and category.
 * Single source of truth for the type/category -> template mapping.
 */
export const getPricebookTemplateFilePath = (priceBookType, pricebookCategory) => {
  if (priceBookType === PricebookType.COMPANY) {
    return pricebookCategory === 'AFFILIATE'
      ? AFFILIATE_COMPANY_PRICEBOOK_FILEPATH
      : COMPANY_PRICEBOOK_FILEPATH;
  }
  if (priceBookType === PricebookType.REFERENCE) {
    return REFERENCE_PRICEBOOK_FILEPATH;
  }
  return GEOGRAPHY_PRICEBOOK_FILEPATH;
};
